module.exports = __webpack_public_path__ + "img/banner_play.557577d7.png";